export default __webpack_public_path__ + "static/nic-barnes-logo-192-2f265375844c75b6a63cc85d36c0d0d7.png";